import { buildSubModuleRoute } from '@/app/arch/helpers/RouterHelper';
import Adq from 'Modules/contacard/adq/register/routes';
import Establishment from 'Modules/contacard/adq/establishment/routes';
import Table from 'Modules/contacard/adq/table/routes';

export default [
  buildSubModuleRoute({
    moduleId: 'contacard',
    name: 'adq',
    path: 'adq',
    subModuleTitle: 'Gerenciar ADQ',
    children: [
      ...Table,
      ...Adq,
      ...Establishment,
    ],
  }),
];
